import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Subscriptions = ({ userData, onUpdate, onFieldChange }) => {
  const [openIndex, setOpenIndex] = useState(null); // Local state for dropdown toggle

  // Hardcoded labels and items (mapped to emailNotifications fields)
  const labels = [
    { label: "Labnext Newsletter", field: "newsletter" },
    { label: "Labnext Daily Summary", field: "dailySummary" },
    { label: "Labnext Activity Log", field: "activityLog" },
    { label: "Cases Created, by the Account", field: "casesCreatedByAccount" },
    { label: "Cases Created, by the Lab", field: "casesCreatedByLab" },
    { label: "Pickup Requests", field: "pickupRequests" },
    { label: "Balance Payments", field: "balancePayments" },
    { label: "Statements", field: "statements" },
    { label: "Invoices", field: "invoices" },
    { label: "Processes", field: "processes" },
    { label: "Accounts", field: "accounts" },
    { label: "Account Changes by Account", field: "accountChangedByAccount" },
    { label: "Account Changes by Lab", field: "accountChangedByLab" },
    { label: "Cases Changed", field: "casesChangedByAccount" }, // Parent field for dropdown
  ];

  const items = [
    {
      title: "Cases changed, by the Account",
      subItems: [
        { label: "Procedures Changed", field: "proceduresChangedByAccount" },
        { label: "Delivery Date Rescheduled", field: "deliveryDateRescheduledByAccount" },
        { label: "Patient Changed", field: "patientChangedByAccount" },
        { label: "On Hold With Proposal Status Changed", field: "onHoldWithProposalStatusChangedByAccount" },
        { label: "Files Changed", field: "filesChangedByAccount" },
        { label: "Case Canceled", field: "caseCanceledByAccount" },
        { label: "Note Added", field: "noteAddedByAccount" },
      ],
    },
    {
      title: "Cases changed, by the Lab",
      subItems: [
        { label: "Procedures Changed", field: "proceduresChangedByLab" },
        { label: "Delivery Date Rescheduled", field: "deliveryDateRescheduledByLab" },
        { label: "Patient Changed", field: "patientChangedByLab" },
        { label: "Account Changed", field: "accountChangedByLab" },
        { label: "Provider Changed", field: "providerChangedByLab" },
        { label: "On Hold Status Changed", field: "onHoldWithProposalStatusChangedByLab" },
        { label: "Case Arrived/Received By The Lab", field: "caseArrivedReceivedByLabByLab" },
        { label: "Components Changed", field: "componentsChangedByLab" },
        { label: "Files Changed", field: "filesChangedByLab" },
        { label: "Case Canceled", field: "caseCanceledByLab" },
        { label: "Case Closed", field: "caseClosedByLab" },
        { label: "Case Plan/Estimate Changed", field: "casePlanEstimateChangedByLab" },
        { label: "Note Added", field: "noteAddedByLab" },
      ],
    },
  ];

  // Handle checkbox changes
  const handleChange = (event) => {
    const { name, checked } = event.target;
    // Map label to field for emailNotifications
    const field = labels.find((item) => item.label === name)?.field || 
                  items.flatMap((item) => item.subItems).find((subItem) => subItem.label === name)?.field;
    if (field) {
      onFieldChange("emailNotifications", field, checked);
    }
  };

  // Toggle dropdown visibility
  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prepare updated data
    const updatedData = {
      ...userData,
      emailNotifications: {
        ...userData.emailNotifications,
      },
    };

    // Call onUpdate to submit changes to the server
    const success = await onUpdate(updatedData);
    if (success) {
      toast.success("Subscriptions updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  return (
    <div style={{ width: "95%", margin: "0 auto", padding: "0" }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="row">
        <div
          className="col-md-2"
          style={{ borderRight: "1px solid #004aad" }}
        ></div>
        <div className="col-md-10">
          <div>
            <h1 className="title">Email Subscriptions</h1>
            <form onSubmit={handleSubmit}>
              <div
                className="Email"
                style={{
                  border: "1px solid #f8f9fa",
                  borderTop: "3px solid #004aad",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <p style={{ marginBottom: "20px" }}>
                  {userData.email
                    ? `Subscriptions will be sent to: ${userData.email}`
                    : "This user does not have an email address. Subscriptions will be sent to the preferred email address: info@hiradentallab.com"}
                </p>
                {labels.map((item, index) => (
                  <div
                    key={index}
                    className={`form-check ${index >= 3 ? "indented-label" : ""}`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name={item.label}
                      checked={userData.emailNotifications[item.field] || false}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor={item.label}>
                      {index < 3 ? <strong>{item.label}</strong> : item.label}
                    </label>
                  </div>
                ))}
                <br />
                {items.map((item, index) => (
                  <div key={index} style={{ marginLeft: "22%" }}>
                    <button type="button" onClick={() => toggleDropdown(index)}>
                      {openIndex === index ? "-" : "+"} {item.title}
                    </button>
                    <br />
                    <br />
                    {openIndex === index && (
                      <div>
                        {item.subItems.map((subItem, subIndex) => (
                          <div key={subIndex}>
                            <input
                              type="checkbox"
                              id={subItem.label}
                              name={subItem.label}
                              checked={userData.emailNotifications[subItem.field] || false}
                              onChange={handleChange}
                            />
                            <label htmlFor={subItem.label}>{subItem.label}</label>
                            <br />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save Subscriptions
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscriptions;